<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span>مدیریت پرسش‌های مربوط به پرسنامه</span> <b> {{ questionInfo.Title }} </b>
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <QuestionsCU :items="items" :question-list-info="questionInfo"/>
    </q-card-section>
    <q-card-section>
      <QuestionsList :items="items" :question-info="questionInfo" @selected-row="selectedRow"/>
    </q-card-section>
  </q-card>
</template>

<script>
import QuestionsCU from "@/components/CustomerQuestions/QuestionsCU";
import QuestionsList from "@/components/CustomerQuestions/QuestionsList";
import {mapActions} from "vuex";

export default {
  name: "Questions",
  components: {QuestionsList, QuestionsCU},
  props: {
    questionInfo: {
      type: Object
    }
  },
  data() {
    return {
      items: [],
      selectedItem: undefined
    }
  },
  methods: {
    ...mapActions({
      crudQuestion: 'Questions/crudQuestions'
    }),
    selectedRow(item) {
      this.$root.$emit('question-selected', item)
    },
  },
  created() {
    this.crudQuestion({action: 'select-base', ParentID: this.questionInfo.ID}).then((res) => {
      this.items = res
    })
  }
}
</script>

<style scoped>

</style>